import { render, staticRenderFns } from "./PlayerInputFactory.vue?vue&type=template&id=6088e84a"
import script from "./PlayerInputFactory.vue?vue&type=script&lang=ts"
export * from "./PlayerInputFactory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports